export const isAlreadyConsolidated = (ewbDetails) => {
    const consolidatedItem = ewbDetails.filter(ewbItem => ewbItem.invoiceNo === "consolidated" && ewbItem.status === "success");
    if (consolidatedItem?.length > 0) {
        return consolidatedItem
    }
    return false;
};